import React, { FC, useContext } from 'react'
import { ToolbarButton } from '@/components/toolbar/atoms'
import { ToolbarElementProps } from '@/model/Toolbar'
import { EditorConfigContext } from '@/context'
import { platformShortCutLabel } from '@/utils/platform.utils'

export const MarksGroup: FC<ToolbarElementProps> = ({ editor }) => {
  const { tools } = useContext(EditorConfigContext)

  const toggleBold = () => editor.chain().focus().toggleBold().run()
  const toggleItalic = () => editor.chain().focus().toggleItalic().run()
  const toggleUnderline = () => editor.chain().focus().toggleUnderline().run()
  const toggleStrike = () => editor.chain().focus().toggleStrike().run()
  const toggleTextCase = () =>
    editor.chain().focus().saveSelection().swapTextCase().restoreSelection('text').run()

  const displayMarks = tools.includes('marks')
  const displayCaseSwap = tools.includes('caseSwap')

  return (
    <>
      {displayMarks && (
        <>
          <ToolbarButton
            title={`Gras (${platformShortCutLabel('$CTRL + B')})`}
            icon="Bold"
            onClick={toggleBold}
            active={editor.isActive('bold')}
            testId = "button-toolbar-editor-bold"
          />
          <ToolbarButton
            title={`Italique (${platformShortCutLabel('$CTRL + I')})`}
            icon="Italic"
            onClick={toggleItalic}
            active={editor.isActive('italic')}
            testId = "button-toolbar-editor-italic"
          />
          <ToolbarButton
            title={`Souligner (${platformShortCutLabel('$CTRL + U')})`}
            icon="Underline"
            onClick={toggleUnderline}
            active={editor.isActive('underline')}
            testId = "button-toolbar-editor-underline"
          />
          <ToolbarButton
            title={`Barrer (${platformShortCutLabel('$CTRL + Shift + S')})`}
            icon="Strikethrough"
            onClick={toggleStrike}
            active={editor.isActive('strike')}
            testId = "button-toolbar-editor-strike"
          />
        </>
      )}

      {displayCaseSwap && (
        <ToolbarButton
          title={`Changer la casse (${platformShortCutLabel('$CTRL + Shift + U')})`}
          icon="CaseSwap"
          onClick={toggleTextCase}
          testId = "button-toolbar-editor-case_swap"
        />
      )}
    </>
  )
}
